import styled from 'styled-components';

export const Wrapper = styled.div`
    a {
        display:flex;
        flex-direction: column;
        border-bottom: 2px solid #ececec;
        padding: 5px 5px;
        color: var(--black);
        text-decoration:none;
        font-size: var(--fontNormal);
        
        label{
            font-size: var(--fontSSmall);
        }
        .title {
            color:var(--morienGreen);
            font-weight:bold;
            /* background-color:var(--lightGreen); */
        }

        .pl-30 {
            padding-left: 30px;
        }

        :hover{
            background-color: #ececec;
            cursor:pointer;
        }
    }
`;